<template>
  <div class="product-payment-sidebar">
    <p class="product-payment-sidebar__intro">
      Select Klarna, PayPal, Afterpay or Affirm as your payment method at
      checkout to enjoy a flexible payment plan tailored to your needs.
    </p>

    <div class="product-payment-sidebar__section">
      <img
        :src="klarnaBadgeLogo"
        alt="Klarna"
        class="product-payment-sidebar__logo product-payment-sidebar__logo--klarna"
      />
      <p class="product-payment-sidebar__headline">
        Pay in 4 or Pay over time.
      </p>
      <p class="product-payment-sidebar__text">
        Split the cost into smaller payments.
        <a
          href="https://www.klarna.com/us/"
          class="product-payment-sidebar__link"
          target="_blank"
          rel="noopener noreferrer"
          >Learn more about Klarna</a
        >
      </p>
    </div>

    <div class="product-payment-sidebar__section">
      <img
        :src="affirmBadgeLogo"
        alt="Affirm"
        class="product-payment-sidebar__logo product-payment-sidebar__logo--affirm"
      />
      <p class="product-payment-sidebar__text">
        Select Amazon Pay or Google Pay at checkout to use Affirm's payment
        plans.
        <a
          href="https://www.affirm.com/"
          class="product-payment-sidebar__link"
          target="_blank"
          rel="noopener noreferrer"
          >Learn more about Affirm</a
        >
      </p>
    </div>

    <div class="product-payment-sidebar__section">
      <img
        :src="afterpayBadgeLogo"
        alt="Afterpay"
        class="product-payment-sidebar__logo product-payment-sidebar__logo--afterpay"
      />
      <p class="product-payment-sidebar__text">
        Split your purchase into 4 interest-free, bi-weekly payments. No late
        fees.
        <a
          href="https://www.afterpay.com/en-US"
          class="product-payment-sidebar__link"
          target="_blank"
          rel="noopener noreferrer"
          >Learn more about Afterpay</a
        >
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import affirmBadgeLogo from "~/assets/img/new-icons/affirm.svg";
import afterpayBadgeLogo from "~/assets/img/new-icons/afterpay.svg";
import klarnaBadgeLogo from "~/assets/img/new-icons/klarna.svg";
</script>
